<template>
  <div class="blank-layout">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BlankLayout'
}
</script>

<style lang="scss" scoped>
.blank-layout {
  min-height: 100vh;
}
</style> 